export function getBoundingPoints(polygon: [number, number][]) {
  const minX = Math.min(...polygon.map((p) => p[0]));
  const maxX = Math.max(...polygon.map((p) => p[0]));
  const minY = Math.min(...polygon.map((p) => p[1]));
  const maxY = Math.max(...polygon.map((p) => p[1]));

  const distance = (p: [number, number], target: { x: number; y: number }) => Math.hypot(p[0] - target.x, p[1] - target.y);

  return {
    topLeft: [...polygon].sort((a, b) => distance(a, { x: minX, y: minY }) - distance(b, { x: minX, y: minY }))[0],
    topRight: [...polygon].sort((a, b) => distance(a, { x: maxX, y: minY }) - distance(b, { x: maxX, y: minY }))[0],
    bottomRight: [...polygon].sort((a, b) => distance(a, { x: maxX, y: maxY }) - distance(b, { x: maxX, y: maxY }))[0],
    bottomLeft: [...polygon].sort((a, b) => distance(a, { x: minX, y: maxY }) - distance(b, { x: minX, y: maxY }))[0],
  };
}
